
import { defineComponent } from "vue";

export default defineComponent({
  name: "custom-layout-masthead",
  props: {
    backgroundUrl: {
      default: "",
      type: String,
    },
    fontSize: {
      default: 1.35,
      type: Number,
    },
    minHeight: {
      default: 35,
      type: Number,
    },
    text: {
      type: String,
    },
    title: {
      type: String,
    },
    subText: {
      type: String,
    },
    subFontSize: {
      default: 1.35,
      type: Number,
    },
  },
  components: {},
});
